import React from 'react';
import { usePageTitle } from '../hooks/usePageTitle';
import PageHeader from '../components/PageHeader';
import { useSettings } from '../context/SettingsContext';

const ReturnPolicy = () => {
  usePageTitle('Chính sách đổi trả và hoàn tiền');
  const { settings } = useSettings();
  const shopName = settings.shop_name || 'Hoa Tháng Năm';

  return (
    <>
      <PageHeader
        title="Chính sách đổi trả và hoàn tiền"
        subtitle="Quy định về việc đổi trả và hoàn tiền khi mua hàng"
        breadcrumb={[
          { text: 'Trang chủ', link: '/' },
          { text: 'Chính sách đổi trả' }
        ]}
      />

      <section className="support-page">
        <div className="container">
          <div className="support-content">
            <p className="support-intro">
              {shopName} cam kết sản phẩm hoa tươi khi giao đến tay người nhận luôn trong tình trạng tốt nhất. Nếu sản phẩm bị hư hỏng trong quá trình vận chuyển, khách hàng vui lòng liên hệ ngay với chúng tôi để yêu cầu đổi sản phẩm hoặc hoàn tiền.
            </p>

            <div className="support-section">
              <h2><span className="section-num">1</span> Chính sách đổi/trả</h2>
              <ul>
                <li>Chúng tôi chịu trách nhiệm cung cấp thông tin đầy đủ, chính xác nhất về các mẫu sản phẩm trên trang web như hình ảnh, màu sắc, kiểu dáng, kích cỡ, số lượng,… Khách hàng cần xem xét kĩ trước khi quyết định đặt mua.</li>
                <li>Sản phẩm của chúng tôi nhận làm hoa tương tự mẫu khách đã chọn. Nếu hoa hoặc giấy gói có sự thay đổi phát sinh, chúng tôi sẽ thông báo với khách để được chủ động linh hoạt thay thế. Đảm bảo không ảnh hưởng đến thẩm mỹ của sản phẩm.</li>
                <li>Chúng tôi chỉ nhận lại sản phẩm khi sản phẩm đó không đúng với miêu tả trên trang web của chúng tôi và không đúng với yêu cầu trong đơn đặt mua của khách hàng.</li>
                <li>Sản phẩm hoa được giao đến tay khách khi chúng tôi đã gửi thông tin xác nhận cho khách trước khi giao không được đổi trả. Nếu lỗi từ phía cửa hàng, vui lòng liên hệ với chúng tôi để đưa ra phương án giải quyết.</li>
                <li>Trong tất cả các trường hợp khác, chúng tôi không chịu trách nhiệm đối với các lỗi không phải do chúng tôi gây ra.</li>
                <li>Sản phẩm trả lại không còn nguyên vẹn, gãy hỏng, bẩn, rách,… do lỗi của khách hàng sẽ không được chấp nhận.</li>
              </ul>
            </div>

            <div className="support-section">
              <h2><span className="section-num">2</span> Chính sách hoàn tiền</h2>
              <ul>
                <li>Trong trường hợp phải hoàn lại tiền sau khi đàm phán giữa chúng tôi và khách hàng, khách hàng sẽ được hoàn từ 50-100% số tiền đã chi trả.</li>
                <li>Thời gian hoàn trả tiền chậm nhất từ 5-7 ngày, kể từ ngày nhận được trả lời chính thức từ phía chúng tôi.</li>
                <li>Khách hàng có thể nhận lại tiền qua hình thức chuyển khoản, VNPAY hoặc tiền mặt,…</li>
              </ul>
            </div>

            <div className="support-section">
              <h2><span className="section-num">3</span> Thay đổi đơn hàng</h2>
              <ul>
                <li>Quý khách có thể chọn lệnh thay đổi đơn hàng mua trên website nếu như chúng tôi chưa thực hiện đơn hàng.</li>
                <li>Thay đổi đơn hàng trước thời điểm giao hoa từ 12h đến 24h hoặc khi sản phẩm chưa được thiết kế, được chấp nhận và không tính phí.</li>
                <li>Chúng tôi không chấp nhận thay đổi sản phẩm ngay trước thời điểm giao hoa hoặc khi sản phẩm đã được thiết kế.</li>
                <li>Trường hợp sản phẩm mới có giá trị nhỏ hơn sản phẩm đã đặt, chúng tôi không hoàn trả tiền chênh lệch.</li>
                <li>Trường hợp sản phẩm mới có giá trị lớn hơn sản phẩm đã đặt, khách hàng phải thực hiện việc thanh toán giá trị chênh lệch cùng phí thay đổi.</li>
                <li>Việc thay đổi sản phẩm và giao hàng sẽ được thực hiện sau khi khách hàng thanh toán hoàn tất.</li>
              </ul>
            </div>

            <div className="support-section">
              <h2><span className="section-num">4</span> Hủy đơn hàng</h2>
              <ul>
                <li>Quý khách có thể hủy lệnh trên website nếu như chúng tôi chưa thực hiện đơn hàng.</li>
                <li>Đối với khu vực Hà Nội &amp; TP.HCM, khách hàng phải hủy đơn đặt trước ít nhất 12 tiếng trong giờ hành chính (7h – 17h).</li>
                <li>Đối với đơn hàng ở các tỉnh thành khác, khách hàng phải hủy đơn trước ít nhất 24 tiếng trong giờ hành chính (7h – 17h).</li>
                <li>Các đơn hàng hủy sau thời gian này vẫn phải thanh toán 100% cho chúng tôi.</li>
              </ul>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default ReturnPolicy;
